jQuery(document).ready(function($) {
	jQuery('.has_hidden p a').on('click', function(e){
		e.preventDefault();
		jQuery('.has_hidden em').slideToggle();
		jQuery('.has_hidden em').toggleClass('show');
		if(jQuery('.has_hidden p a').hasClass('active')){
			jQuery('.has_hidden p a').text('Read Full Story');
			jQuery('.has_hidden p a').removeClass('active');
		}
		else{
			jQuery('.has_hidden p a').text('Hide Full Story');
			jQuery('.has_hidden p a').addClass('active');
		}
	});

    jQuery('.cru-2-col').each(function(){
        parentHeight = jQuery(this).height();
        jQuery(this).children('.image-column').height(parentHeight);
    });
    
    jQuery('a.scroll_to').on('click', function(e){
		e.preventDefault();
		jQuery('a.scroll_to').each(function(){
			jQuery(this).removeClass('active');
		});
		jQuery(this).addClass('active');
		var targ = jQuery(this).attr('href');
		if(targ == "#our-story" && jQuery(window).width() <= 782){
			targ = "#terrior_mobile";
		}
		if(jQuery(window).width() > 900){
			jQuery('html, body').animate({
				scrollTop: jQuery(targ).offset().top - 50
			}, 1000);
		}
		else{
			jQuery('html, body').animate({
				scrollTop: jQuery(targ).offset().top - 50
			}, 1000);
		}
	});

	jQuery('.image-column .slider').slick({
	    infinite: true,
	    dots: true,
	    speed: 500,
	    fade: true,
	    cssEase: 'linear',
	    autoplay: true,
  		autoplaySpeed: 5000,
  		prevArrow:"<i class='fa-solid fa-chevron-left'></i>",
      	nextArrow:"<i class='fa-solid fa-chevron-right'></i>"
	});
	
	var product_item_height = 0;
	jQuery('.cru-product-collection .cru-product-item').each(function(){
		if(jQuery(this).height() > product_item_height){
			product_item_height = jQuery(this).height();
		}
	});
	jQuery('.cru-product-collection .cru-product-item').each(function(){
		jQuery(this).height(product_item_height);
	});

	if(jQuery(window).width() <= 781){
		jQuery('.cru-featured-products').slick({
			infinite: true,
			dots: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			autoplay: false
		});

		jQuery('.layout-grid .cru-product-slider').slick({
			infinite: true,
			dots: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			autoplay: false
		});
	}

	jQuery('a.open_submenu').on('click', function(e){
		e.preventDefault();
		console.log('test');
		jQuery(this).siblings('ul.sub-menu').html();
		if(jQuery(this).hasClass('active')){
			jQuery(this).parent().removeClass('active');
			jQuery(this).removeClass('active');
		}
		else{
			jQuery(this).parent().addClass('active');
			jQuery(this).addClass('active');
		}
	});
	
	jQuery('.cta-block a.btn').on('click', function(e){
		e.preventDefault();
		if(!jQuery(this).siblings('.cta-overlay').hasClass('active')){
			jQuery('.cta-overlay.active').each(function(){
				jQuery(this).removeClass('active');
				jQuery(this).slideToggle();
			});
			jQuery(this).siblings('.cta-overlay').addClass('active');
			jQuery(this).siblings('.cta-overlay').slideToggle();
		}
		else{
			jQuery(this).siblings('.cta-overlay').removeClass('active');
			jQuery(this).siblings('.cta-overlay').slideToggle();
		}
	});

	jQuery('a.accordion_link').on('click', function(e){
		e.preventDefault();
		var targ = jQuery(this).attr('targets');
		jQuery('#'+targ).slideToggle();
	});

	jQuery(document).on('click', 'a.smooth_scroll, .smooth_scroll a', function(e){
		var href = jQuery(this).attr('href');
		if(!href || href.indexOf('#') === -1){
			return;
		}
		var hash = href.substring(href.indexOf('#'));
		var $target = hash.length > 1 ? jQuery(hash) : null;
		if(!$target || !$target.length){
			return;
		}
		e.preventDefault();
		jQuery('html, body').animate({
			scrollTop: $target.offset().top - 50
		}, 800);
	});
});